import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Common/ScrollUp.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Contact/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Countries/index.tsx")